import { Stack } from 'expo-router'
import { stableStackOptions } from '../../../lib/navigation/stable-stack-options'

export default function ProfileLayout() {
  return (
    <Stack screenOptions={{ headerShown: false, ...stableStackOptions }}>
      <Stack.Screen name="index" />
      <Stack.Screen name="edit-profile" />
      <Stack.Screen name="settings" />
      <Stack.Screen name="verification" />
      <Stack.Screen name="notifications" />
      <Stack.Screen name="notifications-prefs" />
      <Stack.Screen name="payment-methods" />
      <Stack.Screen name="privacy" />
      <Stack.Screen name="terms" />
      <Stack.Screen name="cancellation" />
      <Stack.Screen name="imprint" />
      <Stack.Screen name="data-export" />
      <Stack.Screen name="appearance" />
      <Stack.Screen name="delete-account" />
    </Stack>
  )
}
